import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../topic/redux/actions';
import { topicFireEngineerImgs } from '../../images/topicImg'

export class StyleTwoCurriculumItem extends Component {
  static propTypes = {
    topic: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    let { Data, onMeiQiaCustomer } = this.props;

    return (
      <div className="topic-style-two-curriculum-item">
        <div className='curriculum_item_title flex_row' style={{ background: `url(${Data.backgroundImg}) no-repeat` }}>
          <div className='curriculum_title'>{Data.title}</div>
          {Data.recommendImg && <img src={Data.recommendImg} alt="" />}
        </div>
        <div className='section_box'>
          {/* 适合人群 */}
          <div className='suitable_list'>
            <div className='suitable_title'>
              <div>适合人群</div>
              <div className='suitable_background' style={{ background: `url(${Data.subtitleImg}) no-repeat` }}></div>
            </div>
            {Data.SuitableData && Data.SuitableData.map(item => <div className='suitable_item flex_row' key={item.id}>
              <div className='suitable_img_box flex_row'>
                <img src={topicFireEngineerImgs.course_point} alt="" />
              </div>
              <div className='suitable_item_content'>{item.content}</div>
            </div>)}
          </div>
          {/* 课程内容 */}
          <div className='course_content_list'>
            <div className='suitable_title'>
              <div>课程内容</div>
              <div className='suitable_background' style={{ background: `url(${Data.subtitleImg}) no-repeat` }}></div>
            </div>
            {Data.CourseContentData && Data.CourseContentData.map(item => <div className='course_content_item' key={item.id}>
              <div className={Data.totalColor === 'red' ? 'content_item red flex_row' : Data.totalColor === 'blue' ? 'content_item blue flex_row' : 'content_item green flex_row'} style={{ marginBottom: Data.CourseContentData.length > 1 ? '20px' : '0' }}>
                <div className='content_left'>{item.title}</div>
                <div className='content_right'>
                  {item.list && item.list.map(_item => <div className={item.list.length > 1 ? 'marginBottom20' : ''} key={_item.id}>
                    {_item.content}
                  </div>)}
                </div>
              </div>
            </div>)}
          </div>
          {/* 服务保障 */}
          <div className='service_guarantee_list'>
            <div className='suitable_title'>
              <div>服务保障</div>
              <div className='suitable_background' style={{ background: `url(${Data.subtitleImg}) no-repeat` }}></div>
            </div>
            {Data.ServiceAssuranceData && Data.ServiceAssuranceData.map(item => <div className={item.url ? 'service_section_item_img flex_row' : 'service_section_item flex_row'} key={item.id}>
              <div className='service_left'>{item.title}</div>
              <div className='service_right'>
                {item.list ? item.list.map(_item => <div className='flex_row' key={_item.id}>
                  <div className='suitable_img_box flex_row'>
                    <img src={topicFireEngineerImgs.course_point} alt="" />
                  </div>
                  <div className='service_right_content'>{_item.content}</div>
                </div>) : <img src={item.url} alt="" />}
              </div>
            </div>)}
          </div>
          {/* 包含班级 */}
          <div className='contain_class_list'>
            <div className='suitable_title'>
              <div>包含班级</div>
              <div className='suitable_background' style={{ background: `url(${Data.subtitleImg}) no-repeat` }}></div>
            </div>
            {Data.IncludeClassData && Data.IncludeClassData.map(item => <div className='contain_class_item flex_row' key={item.id}>
              <div className='contain_item_left'>{item.title}</div>
              <div className='contain_item_right flex_row'>
                {item.list && item.list.map(_item => <div className='contain_right_item flex_row' key={_item.id}>
                  <div>{_item.content}</div>
                  <img src={_item.icon} alt="" />
                </div>)}
              </div>
            </div>)}
          </div>
          {/* 课程优势 */}
          <div className={Data.combinPriceList.length > 1 ? 'course_advantage_list blue' : 'course_advantage_list'}>
            <div className='suitable_title'>
              <div>课程优势</div>
              <div className='suitable_background' style={{ background: `url(${Data.subtitleImg}) no-repeat` }}></div>
            </div>
            {Data.CourseBenefitsData && Data.CourseBenefitsData.map(item => <div className='course_advantage_item flex_row' key={item.id}>
              <img src={item.icon} alt="" />
              <div dangerouslySetInnerHTML={{ __html: item.content }}></div>
            </div>)}
          </div>
          {/* 套餐组合价 */}
          <div className='combination_price_box'>
            <div className='combination_header flex_row'>
              <div className='combination_left'>套餐组合价</div>
              <div className='combination_right'>
                {Data.combinPriceList && Data.combinPriceList.map(item => <div className='flex_row' style={{ alignItems: 'flex-end', marginBottom: '16px' }} key={item.id}>
                  <div style={{ fontSize: '22px' }}>￥</div>
                  <div className='combination_price'>{item.price}</div>
                  <div className='combination_tips'>{item.tips}</div>
                </div>)}
              </div>
            </div>
            <div className='combination_btns flex_row'>
              <div className='combination_btn flex_row' onClick={onMeiQiaCustomer}>免费试听</div>
              <div className='combination_btn flex_row active' onClick={onMeiQiaCustomer}>马上报名</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    topic: state.topic,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StyleTwoCurriculumItem);



// WEBPACK FOOTER //
// ./src/features/style-two/StyleTwoCurriculumItem.js